<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="filter-wrapper">
                    <p class="title">Manage Filters:</p>
                    <div class="filter-container">
                        <div class="filter-item search-filter">
                            <input type="text" placeholder="Enter Serial No. or Project Name" v-model="filters.search" @change="filter_list">
                            <button type="button" @click="filter_list"><i class="fa fa-search"></i></button>
                        </div>
                        <div class="filter-reset-btn">
                            <a href="javascript:void(0)" title="Refresh" @click="reset_filter">
                                <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                            </a>
                            &nbsp;&nbsp;
                            <a :href="'/project/document-lookup/'+encodeURIComponent(filters.search)" v-if="filters.search && drawings.length">Direct Link</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <div id="ses-list" class="list-proj" @scroll="scroll_list">
                        <div class="row list-head">
                            <div class="col" data-key="serial_number" @click="sort_list">Serial Number</div>
                            <div class="col" data-key="so_number" @click="sort_list">SO Number</div>
                            <div class="col" data-key="project" @click="sort_list">Project Name</div>
                            <div class="col" data-key="customer" @click="sort_list">Customer</div>
                            <div class="col" data-key="bp_code" @click="sort_list">BP Code</div>
                            <div class="col" data-key="datasheets" @click="sort_list">Datasheets</div>
                            <div class="col" data-key="drawing_files" @click="sort_list">Drawings</div>
                            <div class="col" data-key="drawing_files" @click="sort_list">Manuals</div>
                        </div>
                        <div class="list-row" v-for="row in drawings" :key="row.id">
                            <div class="row list-data">
                                <div class="col">{{ row.serial_number }}</div>
                                <div class="col">{{ row.so_number }}</div>
                                <div class="col">{{ row.project }}</div>
                                <div class="col">{{ row.customer }}</div>
                                <div class="col">{{ row.bp_code }}</div>
                                <div class="col">
                                    <span class="pdf-list" v-if="row.datasheets">
                                        <span>Datasheet(s)</span>
                                        <span class="pdf-list-options">
                                            <a 
                                                v-for="(path, key) in row.datasheets" 
                                                :href="'/api/drawing-serial/'+encodeURIComponent(path)" 
                                                target="_blank"
                                                :key="key">
                                                {{ path.split(/[\\/]/).pop() }}
                                            </a>
                                        </span>
                                    </span>
                                </div>
                                <div class="col">
                                    <span class="pdf-list" v-if="row.drawing_files">
                                        <span>Drawing(s)</span>
                                        <span class="pdf-list-options">
                                            <a 
                                                v-for="(dpath, dkey) in row.drawing_files" 
                                                :href="'/api/drawing-serial/'+encodeURIComponent(dpath)" 
                                                target="_blank"
                                                :key="dkey">
                                                {{ dpath.split(/[\\/]/).pop() }}
                                            </a>
                                        </span>
                                    </span>
                                </div>
                                <div class="col">
                                    <span class="pdf-list" v-if="row.manuals">
                                        <span>Manual(s)</span>
                                        <span class="pdf-list-options">
                                            <a 
                                                v-for="(dpath, dkey) in row.manuals" 
                                                :href="'/api/sp/view/WebsiteAsset/'+dpath" 
                                                target="_blank"
                                                :key="dkey">
                                                {{ dkey }} Manual
                                            </a>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="drawings.length == 0 && !isListLoading">
                        <p class="no-results-msg">No results found</p>
                    </template>
                    <template v-if="isListLoading">
                        <div class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'drawings',
    props: {
        serial: String
    },
    data() {
        return {
            apiUrl: '/api/',
            users: [],
            drawings: [],
            isListLoading: false,
            page: 1,
            last_page: 1,
            order_by: 'customer',
            order: 'asc',
            filters: {
                search: '',
                company: 'all',
                role: 'all'
            },
            companies: [],
            roles: [],
            default_select_all_user: false,
            selected_users: [],
            select_all_user_filters: [],
            showBulkEditModal: false
        }
    },
    mounted() {
        let def_order = document.querySelector('#ses-list .list-head .col[data-key='+this.order_by+']')
        def_order.classList.add(this.order)
        def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')

        var user = localStorage.getItem('user');
        if ( !user ) this.$router.push('/login');
        this.user = JSON.parse(user);
    },
    methods: {
        loadDrawings() {
            var user = localStorage.getItem('user');
            if ( !user ) this.$router.push('/login');
            this.user = JSON.parse(user);

            if ( !this.filters.search ) {
                this.drawings = [];
                return false;
            }

            const api = this.apiUrl+'drawing-lookup?page=' + this.page + '&filters=' + JSON.stringify(this.filters);

            this.isListLoading = true;
            this.$http.get(api).then((response) => {
                if(this.page == 1) {
                    this.drawings = [];
                }
                if ( response.data.data ) {
                    // response.data.data.forEach(row => {
                    //     this.drawings.push(row);
                    // })
                    this.drawings = response.data.data;
                    console.log(this.drawings);
                }
                this.isListLoading = false;
            });
        },
        scroll_list(e) {
            console.log(e);
            // if(e.target.scrollTop + e.target.clientHeight >= (e.target.scrollHeight - 50) && !this.isListLoading) {
            //     this.page += 1
            //     if(this.page <= this.last_page) {
            //         this.loadUsers()
            //     }
            // }
        },
        sort_list(e) {
            if(!this.isListLoading) {
                Array.from(document.querySelectorAll('#ses-list .list-head .col')).forEach((el) => {
                    el.classList.remove('asc', 'desc')
                })
                let element = document.querySelector('#ses-list .list-head .col[data-key='+e.target.dataset.key+']')
                this.order_by = e.target.dataset.key
                this.order = element.dataset.order || 'asc'
                element.classList.add(this.order)
                element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
                this.page = 1
                this.users = []
              this.loadDrawings()
            }
        },
        filter_list() {
            this.page = 1
            this.users = []
            this.loadDrawings()
        },
        reset_filter() {
            this.filters = {
                search: '',
                company: 'all',
                role: 'all'
            }
            this.page = 1
            this.users = []
            this.loadDrawings()
        }
    },
    beforeMount(){
        // this.filters.search = this.serial;
        // this.loadDrawings()

        if ( this.$route.params.serial ) {
            this.filters.search = this.$route.params.serial;
            this.loadDrawings()
        }
    }
};
</script>
<style lang="scss" scoped>
.pdf-list { text-transform: uppercase; position: relative; padding: 3px; cursor: pointer; display: inline-block; }
.pdf-list a { display: inline-block; }
.pdf-list > span { display: inline-block; padding: 3px; }
.pdf-list > .pdf-list-options, .pdf-list > .pdf-list-options a { color: #000 !important; }
.pdf-list .pdf-list-options { display: none; position: absolute; top: 100%; right: 0; background: #FFF; padding: 4px 6px; white-space: nowrap; }
.pdf-list:hover .pdf-list-options { display: block; }
.list-proj .pdf-list .pdf-list-options a { margin: 0; }
.ses-content .filter-wrapper .filter-item.search-filter { width: 350px; }
.row.list-data { min-height: 48px; }
#ses-list {
    min-width: 700px;
    padding-right: 12px;
    max-height: 500px;
    .list-head .col {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('/api/public/img/bg.png');
        background-position: center right;
        background-repeat: no-repeat;
        cursor: pointer;
        white-space: normal;
        &.asc {
            background-image: url('/api/public/img/trans-asc.png');
        }
        &.desc {
            background-image: url('/api/public/img/trans-desc.png');
        }
        &.sort-false {
            background-image: none;
            cursor: default;
        }
    }
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.col-check-th,
.col-check-td {
    flex-grow: 0;
}
.col-check-th {
    padding-left: 32px;
}
.col-check-td {
    padding-left: 25px;
}
.btnDeselectAllUser {
    background-color: #c90000;
    color: #fff;
    font-size: 11px;
    border-radius: 50%;
    height: 24px;
    width: 24px !important;
    padding: 0;
    position: absolute;
    z-index: 10;
    right: -14px;
    top: -9px;
    &:hover {
        color: #000;
    }
}
.button-group {
    .btn-bulk-edit {
        width: 100%;
        margin-right: 0;
        .btn {
            width: 100%;
        }
    }
}
@media (min-width: 568px) {
    .button-group {
        .btn-bulk-edit {
            width: 48%;
            margin-right: 8px;
        }
    }
}
@media (min-width: 992px) {
    .button-group {
        .btn-bulk-edit {
            width: auto;
        }
    }
}
@media (max-width: 768px) {
    #ses-list {
        min-width: 1200px;
    }
}
</style>
